import { render, staticRenderFns } from "./PatientCalendar.vue?vue&type=template&id=285ef929&"
import script from "./PatientCalendar.vue?vue&type=script&lang=js&"
export * from "./PatientCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports